import Swiper from 'swiper/dist/js/swiper';
import debounce from 'lodash.debounce';
import autoplayHandle from './autoplayHandle';
import { mainOptions, thumbsOptions } from './slidersOptions';

const bannerSlider = (wrapper) => {

  if (!wrapper) return;

  const mainSliderEl = wrapper.querySelector('.js-banner-slider-main');
  const thumbsEl = wrapper.querySelector('.js-banner-slider-thumbs');
  const slides = Array.prototype.slice.call(mainSliderEl.querySelectorAll('.swiper-slide'));
  const slidesLength = slides.length;
  const prev = wrapper.querySelector('.js-swiper-button-prev');
  const next = wrapper.querySelector('.js-swiper-button-next');

  const mainSlider = new Swiper(mainSliderEl, mainOptions({ slidesLength, prev, next }));
  let thumbsSlider = new Swiper(thumbsEl, thumbsOptions({ slidesLength }));

  autoplayHandle({ mainSlider, thumbsSlider });

  function sliderOnResize() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (isMobile) {
      if (typeof thumbsSlider === "undefined" || !thumbsSlider.initialized) return;
      thumbsSlider.destroy();
      thumbsSlider = undefined;
      thumbsEl.querySelector('.swiper-wrapper').removeAttribute('style');
      mainSlider.controller.control = false;
    } else {
      thumbsSlider = new Swiper(thumbsEl, thumbsOptions({ slidesLength }));
      thumbsSlider.init();
      mainSlider.controller.control = thumbsSlider;
      thumbsSlider.controller.control = mainSlider;
    }
  }

  window.addEventListener('resize', debounce(sliderOnResize, 500));
  sliderOnResize();

};
export default bannerSlider;
